import { AxiosResponse } from "axios"
import { axiosInstanceWebsite } from "../instance"
import { cachedRequest } from "../../utils/requestCache";

const PRODUCT_DETAIL_TTL_MS = 5 * 60_000;

export const getProductDetail = async (productId: string) => {
    return cachedRequest(`product-detail:${productId}`, PRODUCT_DETAIL_TTL_MS, async () => {
    const response: AxiosResponse = await axiosInstanceWebsite.get(
        `store/product/${productId}`,
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    )
    return response.data;
    });
}
